import { Box, Divider } from "@chakra-ui/react";

export function SidebarDivider(props) {
  return (
    <Box mx={props.navSize == "small" ? 3 : 4}>
      <Divider />
    </Box>
  );
}
